import type { Collection } from "../lib/types/schema/collection/collectionSchema";
import type { TrustedCollection } from "../lib/types/schema/collection/trustedCollectionSchema";

type GetIsCollectionAlbumOnlyWithSongsProps = {
  collection: Collection | TrustedCollection;
};

export const getIsCollectionAlbumOnlyWithSongs = ({
  collection,
}: GetIsCollectionAlbumOnlyWithSongsProps) => {
  if (!collection.is_album) return false;

  return collection.prayers.every((prayer) => prayer.is_song);
};
